export function modal() {
  //オーバーレイ
  let overlay = document.querySelector('.c-modal_overlay');
  //モーダルを起動させる要素
  let target = document.querySelectorAll('.js-modal_target');

  //モーダル起動
  for (let i = 0; i < target.length; i++) {
    target[i].addEventListener('click', () => {
      overlay.classList.add('is-view');
      let num = target[i].getAttribute('data-target');
      let modal = document.querySelector('.modal' + num);
      target[i].classList.add('is-active');
      modal.classList.add('is-view');

      //クローズ処理
      function modalClose() {
        overlay.classList.remove('is-view');
        target[i].classList.remove('is-active');
        modal.classList.remove('is-view');
      }

      // オーバーレイクリック時クローズ
      overlay.addEventListener('click', () => {
        modalClose();
      });

      // クローズボタン
      let close = document.querySelectorAll('.c-modal_close');
      //クローズボタンクリック時クローズ
      for (let i = 0; i < close.length; i++) {
        close[i].addEventListener('click', () => {
          modalClose();
        });
      }
    });
  }

}